import { FlagGetter } from "@/FeatureFlag";
import {
  allDestinationsData,
  DestinationDefinition,
  RequestableSaasDestination,
} from "@/destinations/destinations";

/** Destinations that may be offered in the catalog, before entitlement checks. */
export function getCatalogDestinations(
  flag: FlagGetter,
): DestinationDefinition[] {
  return (
    Object.values(allDestinationsData)
      .filter((d) => !(d instanceof RequestableSaasDestination))
      // TODO(dylan): Remove this filter when legacy personas destinations are
      // fully removed For now, this ensures that the destinations do not
      // appear unless the legacy personas feature flag is enabled
      .filter(
        (d) =>
          d.name !== "Google Ads Remarketing Lists" &&
          d.name !== "Facebook Custom Audiences",
      )
      // Google Ads Conversion API (Data Manager) is gated behind a feature
      // flag while it's in development / pre-GA, so it's only visible to
      // accounts with the flag enabled.
      .filter(
        (d) =>
          d.slug !== "google-data-manager-conversion-api" ||
          flag("googleDataManagerConversionApi"),
      )
      .filter((d) => d.slug !== "linkedin-ads")
      // TODO: Remove this filter when Cadent delivery is implemented
      .filter((d) => d.slug !== "cadent")
      // TODO: Remove this filter when Amazon Ads Events API delivery is available
      .filter((d) => d.slug !== "amazon-ads-events-api")
      // TODO: Remove this filter when Quantcast is available for all users
      .filter((d) => d.slug !== "quantcast")
  );
}
